import React from 'react';

import styles from './styles.module.css';

interface EmptyDataProps {
  label: string;
}

const EmptyData: React.FC<EmptyDataProps> = ({
  label = 'No data available'
}) => {
  return (
    <div id={`${label}-empty-data`} className={styles.emptyState}>
      {label}
    </div>
  );
};

export default EmptyData;
